var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-page px-md-5" },
    [
      _c("lists-header", { attrs: { title: _vm.$tc("lists.list", 2) } }),
      _vm._v(" "),
      _c("lists-search"),
      _vm._v(" "),
      _vm.loading
        ? _c("lists-table-loader")
        : _c("lists-table", { attrs: { lists: _vm.lists } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }